import { faces as f } from "@patient-watch/icons";

export const sliderFace = (value: number) => {
    switch (value) {
        case 0:
            return { message: "No pain at all", icon: <f.Zero /> };
        case 1:
            return { message: "Almost no pain", icon: <f.One /> };
        case 2:
            return { message: "Very little pain", icon: <f.Two /> };
        case 3:
            return { message: "Little pain", icon: <f.Three /> };
        case 4:
            return { message: "Some pain", icon: <f.Four /> };
        case 5:
            return { message: "More pain", icon: <f.Five /> };
        case 6:
            return { message: "Considerable pain", icon: <f.Six /> };
        case 7:
            return { message: "A lot of pain", icon: <f.Seven /> };
        case 8:
            return { message: "Loads of pain", icon: <f.Eight /> };
        case 9:
            return { message: "Awful pain", icon: <f.Nine /> };
        case 10:
            return { message: "Worst possible pain", icon: <f.Ten /> };
        default:
            return { message: "Pain level", icon: <f.Five /> };
    }
};
